"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const icons_1 = require("./common/icons");
const FormCard_1 = __importDefault(require("./FormCard"));
const NoForms_1 = __importDefault(require("./NoForms"));
const FieldTypeCard_1 = __importDefault(require("./FieldTypeCard"));
const api_1 = require("../api");
const FormSettingsContext_1 = require("../context/FormSettingsContext");
const fieldTypes = [
    { label: "Textarea", icon: (0, jsx_runtime_1.jsx)(icons_1.TextAreaIcon, {}) },
    { label: "Text Field", icon: (0, jsx_runtime_1.jsx)(icons_1.TextFieldIcon, {}) },
    { label: "Multiple choice", icon: (0, jsx_runtime_1.jsx)(icons_1.MultipleChoiceIcon, {}) },
    { label: "Checkboxes", icon: (0, jsx_runtime_1.jsx)(icons_1.CheckboxIcon, {}) },
    { label: "Drop-down", icon: (0, jsx_runtime_1.jsx)(icons_1.DropdownIcon, {}) },
    { label: "File upload", icon: (0, jsx_runtime_1.jsx)(icons_1.FileUploadIcon, {}) },
    { label: "Date", icon: (0, jsx_runtime_1.jsx)(icons_1.DateIcon, {}) },
    { label: "Time", icon: (0, jsx_runtime_1.jsx)(icons_1.TimeIcon, {}) },
    { label: "Phone", icon: (0, jsx_runtime_1.jsx)(icons_1.PhoneIcon, {}) },
    { label: "Email", icon: (0, jsx_runtime_1.jsx)(icons_1.EmailIcon, {}) },
];
const FormList = ({ selectedTab, search, onSelectForm }) => {
    const { forms, setForms } = (0, FormSettingsContext_1.useFormSetting)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (selectedTab === "existing") {
            loadForms();
        }
    }, [selectedTab]);
    const loadForms = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setError(null);
        try {
            const result = yield (0, api_1.fetchForms)();
            setForms(result);
        }
        catch (err) {
            console.error("Error loading forms:", err);
            setError("Failed to load forms. Please try again later.");
        }
        finally {
            setLoading(false);
        }
    });
    const filtered = forms.filter((f) => f.title.toLowerCase().includes(search.toLowerCase()));
    if (selectedTab === "existing" && loading) {
        return ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", justifyContent: "center", mt: 4, children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 24 }) }));
    }
    if (selectedTab === "existing" && error) {
        return ((0, jsx_runtime_1.jsx)(material_1.Box, { textAlign: "center", mt: 4, color: "error.main", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: error }) }));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { flex: 1, overflow: "auto", display: "flex", flexDirection: "column", gap: 1, children: selectedTab === "existing" ? (filtered.length > 0 ? (filtered.map((form) => ((0, jsx_runtime_1.jsx)(material_1.Box, { onClick: () => onSelectForm(form), sx: { cursor: "pointer" }, children: (0, jsx_runtime_1.jsx)(FormCard_1.default, { form: form }) }, form._id)))) : ((0, jsx_runtime_1.jsx)(NoForms_1.default, { icon: (0, jsx_runtime_1.jsx)(icons_1.ExistingFormLogoIcon, { width: 48, height: 48 }), title: "No Forms Available", description: "You haven\u2019t created any forms yet. Start by clicking New Form above to build your first one." }))) : ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", flexWrap: "wrap", gap: 1, p: 1, children: fieldTypes.map((field) => ((0, jsx_runtime_1.jsx)(material_1.Box, { width: { xs: "100%", sm: "calc(50% - 0.5rem)" }, children: (0, jsx_runtime_1.jsx)(FieldTypeCard_1.default, { label: field.label, icon: field.icon }) }, field.label))) })) }));
};
exports.default = FormList;
